import Shimmer from "@/components/Shimmer";

const PolicyEditorFormLoader = ({
  updateType,
}: {
  updateType: "ADD" | "EDIT";
}) => (
  <div className="flex flex-col gap-20 bg-gray-light p-20 md:gap-10">
    <Shimmer height={72} />
    <div className="flex flex-col gap-20 md:flex-row md:gap-10">
      <Shimmer height={60} width={160} />
      <Shimmer height={60} width="100%" />
      <Shimmer height={60} width={160} />
    </div>
    <Shimmer height={updateType === "ADD" ? 200 : 700} />
    <Shimmer height={100} />
  </div>
);

export default PolicyEditorFormLoader;
